// Libraries
import React from 'react';
import ReactDOM from 'react-dom';

import { Index as Main } from './__business/Index'

let Core

Core = Main

ReactDOM.render(<Core/>, document.getElementById('root'));